<script setup>
import FullPopup from '#/general/FullPopup'
import { useB2CAnalyzer } from 'src/composables/useB2CAnalyzer'
import BackButton from 'components/general/BackButton'
import { inject } from 'vue'
const { showB2cMaxRequestPopup, form } = useB2CAnalyzer()
const { showB2CQuestionnairePopup } = inject('Shared')
function goBack () {
  showB2cMaxRequestPopup.value = false
  setTimeout(() => {
    showB2CQuestionnairePopup.value = true
  }, 300)
}
function sendMail () {
  window.location.href = 'mailto:andreas@raumpioniere.ch'
}
</script>

<template lang="pug">
full-popup(
  :fixed="true"
  :persistent="true"
  v-model:visible="showB2cMaxRequestPopup"
  btn-label="Sales-Team kontaktieren"
  title="Sie haben die maximale Anzahl an Abfragen erreicht."
  @clicked="sendMail"
  filter-color="rgba(255, 255, 255, 0.5)"
)
  .b2c-max-request--container
    .box Liebe/r {{form.fields.firstName.value}} {{form.fields.lastName.value}},
    .box Um unser Produkt zu schützen, sind aktuell nur maximal drei Adressabfragen möglich.
    .box Sie möchten mehr als drei Abfragen durchführen? Dann nehmen Sie mit unserem Sales-Team Kontakt auf - Wir freuen uns auf den Austausch.
  template(#bottom)
    back-button(@click="goBack")
</template>

<style lang="sass">
.b2c-max-request--container
  color: #DCE7F2
  line-height: 130%
  @media screen and (min-width: 1024px)
    font-weight: 500
    font-size: 16px
  @media screen and (max-width: 1023px)
    font-weight: 500
    font-size: 14px
  .box
    margin-bottom: 20px
</style>
